<template>
  <div>

    <!-- Main Row -->
    <div class="row">

      <!-- Form -->
      <div class="col-md-12">
        <Card :title="'Edit Biaya Layanan'">
          <template v-slot:body>
            <Form
              :form="form"
              :route="'payment-categories/' + form.id"
            />
          </template>
        </Card>
      </div>

    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue"
import Form from '@/component/masters/payment-categories/Form.vue'
import module from '@/core/modules/CrudModule.js'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  components: {
    Card,
    Form
  },

  data() {
    return {
      // Form
      form: {
        name: '',
        price: '',
        description: '',
        payment_category_type_id: '',
        doctor_commission: '',
        hospital_income: '',
      },
    }
  },

  methods: {

    async get() {
      this.form = await module.get('payment-categories/' + this.$route.params.id)
      // If Data Not Found
      if (this.form == null) {
        // Redirect To List
        this.$router.push('/payment-category/list')
      } else {
        this.form['_method'] = 'put'
        this.form.price = parseInt(this.form.price).toLocaleString('id-ID')
      }
    }

  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Keuangan", route: "" },
      { title: "Daftar Biaya Layanan", route: "/payment-category/list" },
      { title: "Ubah" },
    ])
    // Get Data
    this.get()
  },

}

</script>